import { useId } from 'react';
import { TEMPLATES_COPY } from './agent-templates-copy';
import styles from './AgentTemplatesSection.module.css';
import { TemplateCard } from './TemplateCard';
import { useAgentTemplates, useGrantableTools, useTemplateGrantMutation } from './useAgentTemplates';

export const AgentTemplatesSection = () => {
  const headingId = useId();
  const templatesQuery = useAgentTemplates();
  const toolsQuery = useGrantableTools();
  const { pendingGrantKey, banner, addGrant, removeGrant } = useTemplateGrantMutation();

  const isLoading = templatesQuery.isLoading;
  const failedToLoad = templatesQuery.isError;
  const isReady = !isLoading && !failedToLoad;
  const templates = templatesQuery.data ?? [];
  const grantableTools = toolsQuery.isError ? undefined : toolsQuery.data;
  const hasTemplates = templates.length > 0;
  const showCards = isReady && hasTemplates;
  const showNotProvisioned = isReady && !hasTemplates;

  const cards = templates.map(template => (
    <TemplateCard
      key={template.id}
      template={template}
      tools={grantableTools}
      pendingGrantKey={pendingGrantKey}
      onAddGrant={target => addGrant(template, target)}
      onRemoveGrant={grantId => removeGrant(template, grantId)}
    />
  ));

  return (
    <section className={styles.section} aria-labelledby={headingId}>
      <h2 id={headingId}>{TEMPLATES_COPY.heading}</h2>
      <p className={styles.description}>{TEMPLATES_COPY.description}</p>
      {(banner || toolsQuery.isError) && (
        <div role="alert">
          {banner && <p className={styles.banner}>{banner}</p>}
          {toolsQuery.isError && <p className={styles.error}>{TEMPLATES_COPY.toolsLoadError}</p>}
        </div>
      )}
      {isLoading && <p className={styles.loading}>{TEMPLATES_COPY.loading}</p>}
      {failedToLoad && <p className={styles.error}>{TEMPLATES_COPY.loadError}</p>}
      {showNotProvisioned && <p className={styles.empty}>{TEMPLATES_COPY.notProvisioned}</p>}
      {showCards && <div className={styles.cards}>{cards}</div>}
    </section>
  );
};
